module.exports = __webpack_public_path__ + "img/sv29.62e8211e.svg";